module.exports = __webpack_public_path__ + "static/img/filter-outline.6a02ba95.svg";